module.exports = __webpack_public_path__ + "img/zhu_yj_zhangtianfu.28abfe4e.jpg";